










import HistoryRow from "./HistoryRow.vue";
export default {
    name: "History",
    components: { HistoryRow },
    props: {
        modificationHistory: Array,
    },
};
